import { Modal } from '../../shared/modal';
import Notification from '../../shared/notification';
import QuoteList from '../views/quote-list';
import Handlebars from '../../shared/handlebar-helpers';

export const handleQuotesClick = async (e, app) => {
    const modal = new Modal({ containerId: 'quote-modal' });
    const sellerId = app.session.sellerDetails.id;
    const currentQuoteId = app.session.currentQuoteId;

    const notification = new Notification({ type: 'loading' });

    if (app.service.getSession()?.state === 'expired') {
        return app.login.open();
    }
    
    notification.open();
    const { data, status, message } = await app.service.getQuotes(sellerId, {
        order: 'DESC',
    });

    if (data) {

        const quotesData = {
            quotes: data.quotes,
            wins: data.wins,
            states: data.states,
            closedStates: Handlebars.closedStates,
            currentQuoteId
        };

        // Set up onClose callback to show icon when modal closes
        modal.onClose = () => {
            app.menu.showIcon();
        };

        const quotes = new QuoteList(modal, quotesData, app);
        quotes.open();
        notification.close();
        
        // Hide icon when quote list opens successfully
        app.menu.hideIcon();
    } else {
        app.menu.getHandler().close();

        notification.reload({
            type: 'error',
            message,
        });
    }


};
